/**
 * Padel Moris Level System — maps ELO rating to 10 skill tiers.
 * Original tier names and descriptions by Padel Moris.
 */

export const PADEL_LEVELS = [
  { level: 1,  name: "level.1",  desc: "level.1.desc",  minElo: 0,    maxElo: 799,  color: "bg-red-500",     text: "text-red-500",     bg: "bg-red-500/10",     border: "border-red-500/20" },
  { level: 2,  name: "level.2",  desc: "level.2.desc",  minElo: 800,  maxElo: 899,  color: "bg-red-400",     text: "text-red-400",     bg: "bg-red-400/10",     border: "border-red-400/20" },
  { level: 3,  name: "level.3",  desc: "level.3.desc",  minElo: 900,  maxElo: 999,  color: "bg-orange-500",  text: "text-orange-500",  bg: "bg-orange-500/10",  border: "border-orange-500/20" },
  { level: 4,  name: "level.4",  desc: "level.4.desc",  minElo: 1000, maxElo: 1099, color: "bg-blue-500",    text: "text-blue-500",    bg: "bg-blue-500/10",    border: "border-blue-500/20" },
  { level: 5,  name: "level.5",  desc: "level.5.desc",  minElo: 1100, maxElo: 1199, color: "bg-blue-400",    text: "text-blue-400",    bg: "bg-blue-400/10",    border: "border-blue-400/20" },
  { level: 6,  name: "level.6",  desc: "level.6.desc",  minElo: 1200, maxElo: 1299, color: "bg-teal",        text: "text-teal",        bg: "bg-teal/10",        border: "border-teal/20" },
  { level: 7,  name: "level.7",  desc: "level.7.desc",  minElo: 1300, maxElo: 1399, color: "bg-green-500",   text: "text-green-500",   bg: "bg-green-500/10",   border: "border-green-500/20" },
  { level: 8,  name: "level.8",  desc: "level.8.desc",  minElo: 1400, maxElo: 1549, color: "bg-purple-500",  text: "text-purple-500",  bg: "bg-purple-500/10",  border: "border-purple-500/20" },
  { level: 9,  name: "level.9",  desc: "level.9.desc",  minElo: 1550, maxElo: 1749, color: "bg-golden",      text: "text-golden",      bg: "bg-golden/10",      border: "border-golden/20" },
  { level: 10, name: "level.10", desc: "level.10.desc", minElo: 1750, maxElo: 9999, color: "bg-coral",       text: "text-coral",       bg: "bg-coral/10",       border: "border-coral/20" },
];

export function getPadelLevel(elo) {
  const rating = Math.round(elo || 1200);
  for (let i = PADEL_LEVELS.length - 1; i >= 0; i--) {
    if (rating >= PADEL_LEVELS[i].minElo) return PADEL_LEVELS[i];
  }
  return PADEL_LEVELS[0];
}

/**
 * Returns a decimal level string like "6.3" based on ELO.
 * The decimal represents progress within the current level (0-9).
 * e.g. ELO 1230 in Level 6 (1200-1299) → 6.3 (30% through the range)
 */
export function getDecimalLevel(elo) {
  const rating = Math.round(elo || 1200);
  const lvl = getPadelLevel(rating);
  const range = lvl.maxElo === 9999 ? 250 : (lvl.maxElo - lvl.minElo + 1);
  const progress = Math.min(rating - lvl.minElo, range) / range;
  const decimal = Math.floor(progress * 10);
  return `${lvl.level}.${Math.min(decimal, 9)}`;
}

export function groupPlayersByLevel(players) {
  const groups = {};
  for (const p of players) {
    const lvl = getPadelLevel(p.elo_rating);
    if (!groups[lvl.level]) {
      groups[lvl.level] = { ...lvl, players: [] };
    }
    groups[lvl.level].players.push(p);
  }
  // Return sorted descending by level
  return Object.values(groups).sort((a, b) => b.level - a.level);
}
